import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@env/environment';

export const withCredentialsInterceptor: HttpInterceptorFn = (req, next) => {
  const secureReq = req.clone({
    withCredentials: true,
    setHeaders: {
      'X-Requested-By': environment.xRequestedBy
    }
  });
  return next(secureReq);
};
